import script from "./zyxds_notices.vue?vue&type=script&setup=true&lang=js"
export * from "./zyxds_notices.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__